import { makeCompressionStream, makeDecompressionStream } from './ponyfill.mjs';
const globals = typeof globalThis == 'undefined'
    ? typeof self == 'undefined'
        ? typeof global == 'undefined'
            ? {}
            : global
        : self
    : globalThis;
if (typeof globals.CompressionStream == 'undefined') {
    globals.CompressionStream = makeCompressionStream(TransformStream);
}
if (typeof globals.DecompressionStream == 'undefined') {
    globals.DecompressionStream = makeDecompressionStream(TransformStream);
}
